import { useState } from 'react';
import { Typography, TextSize } from '@shared/index';
import { formatNum } from '@app/utils/math';
import { daysUntilEndOfMonth } from '@app/utils/date';
import { ProgressGraph } from '../progress-graph';
import * as Tooltip from '@radix-ui/react-tooltip';
import { QuarterlyHistoryPopup } from './history-popup';
import { getCurrentDate } from '@shared/utils/getCurrentDate';
import { useGetTeamQuarterlyBonus } from '@entities/managers-perfomance';

export const QuarterlyTeamBonus = () => {
  const [isPopupOpen, setIsPopupOpen] = useState<boolean>(false);
  const { year, month } = getCurrentDate();

  const { data: teamMonthlyGoal } = useGetTeamQuarterlyBonus({
    year,
    month,
  });

  const {
    plan = 0,
    hashrate: currentValue = 0,
    percentage: percent = 0,
    remaining_hashrate: remainingValue = 0,
  } = teamMonthlyGoal ?? {};

  const remainingPercent = plan ? (remainingValue / plan) * 100 : 0;

  const daysLeft = daysUntilEndOfMonth();

  const infoCards = [
    { label: 'План', value: formatNum(plan), unit: 'Ph' },
    { label: 'Осталось', value: daysLeft, unit: 'дн' },
  ];

  return (
    <div className="flex flex-col gap-6">
      <div className="flex items-center gap-2">
        <Typography
          size={TextSize.size24}
          className="font-semibold"
          title="Квартальный бонус команды"
        />
        <Tooltip.Provider>
          <Tooltip.Root>
            <Tooltip.Trigger asChild>
              <div className="cursor-pointer" onClick={() => setIsPopupOpen(true)}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M10 0C4.486 0 0 4.486 0 10C0 15.514 4.486 20 10 20C15.514 20 20 15.514 20 10C20 4.486 15.514 0 10 0ZM10 18C5.589 18 2 14.411 2 10C2 5.589 5.589 2 10 2C14.411 2 18 5.589 18 10C18 14.411 14.411 18 10 18Z"
                    fill="white"
                  />
                  <path
                    d="M10 3.16604V10H16.834C16.8362 9.10195 16.661 8.21228 16.3184 7.38213C15.9757 6.55198 15.4724 5.79771 14.8374 5.16267C14.2023 4.52763 13.4481 4.02432 12.6179 3.68168C11.7878 3.33903 10.8981 3.16379 10 3.16604Z"
                    fill="white"
                  />
                </svg>
              </div>
            </Tooltip.Trigger>
            <Tooltip.Portal>
              <Tooltip.Content
                className="bg-white text-black text-[10px] font-semibold px-3 py-2 rounded-md shadow-lg z-50"
                side="top"
                sideOffset={5}
              >
                История по кварталам
                <Tooltip.Arrow className="fill-white" />
              </Tooltip.Content>
            </Tooltip.Portal>
          </Tooltip.Root>
        </Tooltip.Provider>
        <QuarterlyHistoryPopup
          open={isPopupOpen}
          onClose={() => setIsPopupOpen(false)}
          year={year}
        />
      </div>
      <div className="flex justify-between items-end gap-6">
        <div className="flex flex-col gap-[10px]">
          {infoCards.map(({ label, value, unit }) => (
            <div
              key={label}
              className="w-[224px] flex justify-between items-center bg-dark-200 rounded-md px-2 py-1"
            >
              <Typography size={TextSize.size14} className="text-gray-400" text={`${label}:`} />
              <div className="flex gap-1 items-start">
                <Typography size={TextSize.size20} text={value} />
                <span className="text-xs text-gray-400">{unit}</span>
              </div>
            </div>
          ))}
        </div>
        <ProgressGraph
          percent={percent}
          currentValue={currentValue}
          plan={plan}
          remainingPercent={remainingPercent}
          remainingPh={formatNum(remainingValue)}
          progressColor="#9289F3"
          indicatorColor="#B1ABF5"
        />
      </div>
    </div>
  );
};
